var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"btn btn--purple gradient margin-correct",attrs:{"type":"button"},on:{"click":_vm.openPaymentPage}},[_c('i',{}),_vm._v(" Manage payment method & view invoices ")])
}
var staticRenderFns = []

export { render, staticRenderFns }